export default "__VITE_ASSET__f0194ee2__"